// FAQ zur Leistungsübersicht — gespeist ins FAQPage-Schema
// (routes/leistungen.index.tsx).
export const leistungenFaq = [
  {
    question: "Was kostet eine Webseite?",
    answer:
      "Die Kosten für eine Webseite hängen von Anzahl der Seiten, Komplexität und Design ab. Richtwerte: Einfache Webseiten ab ca. 1.500€, Unternehmenswebseiten ab ca. 3.000€, komplexe Projekte ab ca. 5.000€.",
  },
  {
    question: "Wie lange dauert die Erstellung einer Webseite?",
    answer:
      "Die Projektdauer variiert je nach Umfang: Einfache Webseiten 2-4 Wochen, Unternehmenswebseiten 4-8 Wochen, komplexe Projekte 8-12 Wochen oder länger.",
  },
  {
    question: "Wie läuft ein Projekt bei Ihnen ab?",
    answer:
      "Unser Prozess: 1. Erstgespräch - Anforderungen kennenlernen, 2. Angebot mit Kostenaufstellung, 3. Konzeption & Design, 4. Entwicklung, 5. Testing & Launch.",
  },
  {
    question: "Was kostet das Hosting?",
    answer:
      "Unsere Hosting-Pakete starten ab 15€/Monat und beinhalten SSL-Zertifikat, tägliche Backups, E-Mail-Postfächer, technischen Support und Sicherheitsupdates.",
  },
  {
    question: "Bieten Sie auch Wartung und Support an?",
    answer:
      "Ja! Wir bieten verschiedene Wartungspakete an, die regelmäßige Updates, Sicherheitschecks und schnellen Support beinhalten. Bei Bedarf übernehmen wir auch inhaltliche Änderungen.",
  },
  {
    question: "Ist SEO in der Webseite enthalten?",
    answer:
      "Grundlegende SEO-Maßnahmen sind bei jeder Webseite inklusive: suchmaschinenfreundliche Struktur, optimierte Ladezeiten, mobile Optimierung, Meta-Tags und Alt-Texte.",
  },
  {
    question: "Wie sind die Zahlungsbedingungen?",
    answer:
      "Wir bieten flexible Zahlungsmodelle: Standardzahlung (50% bei Projektstart, 50% bei Fertigstellung), Ratenzahlung auf Anfrage, und monatliche oder jährliche Abrechnung für Hosting & Wartung.",
  },
];
